<template lang="pug">
  div.n-select.select-wrapper
    select.dropdown(v-model="value_" :class="disabled && 'disabled'")
      option(
        v-if="showEmptyItem"
        disabled
        value="-1"
      ) -- bitte wählen --

      option(
        v-if="showEmptyItem"
        value=""
        style="display: none;"
        :selected="!value_"
      )

      option(
        v-for="item, i in items"
        :value="getItemValue(item)"
        :key="i"
        :selected="getItemValue(item) === value"
      ) {{ getItemText(item) }}

    div.hint-wrapper(v-if="info")
      .hint.info.open {{ info }}

    div.hint-wrapper(v-if="error")
      .hint.error.open {{ error }}

</template>

<script>
export default {
  name: 'n-select',

  props: {
    items: {
      type: Array
    },

    value: {
      type: [ String, Number ],
      default: ''
    },

    valueField: {
      type: String,
      default: ''
    },

    textField: {
      type: String,
      default: ''
    },

    showEmptyItem: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    info: {
			type: String,
			default: ''
    },

    error: {
			type: String,
			default: ''
		},
  },

  computed: {
    value_: {
      get () {
        return this.value;
      },

      set (v) {
        this.$emit('input', v);
      }
    }
  },

  methods: {
    getItemValue(item) {
      return this.valueField
        ? item[this.valueField]
        : item;
    },

    getItemText(item) {
      return this.textField
        ? item[this.textField]
        : item;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/n-select.vue